package ext

import org.w3c.dom.HTMLElement
import org.w3c.dom.Node

/**
 * Insert the given node as the first child of this element.
 */
fun HTMLElement.insertAsFirst(node: Node) = firstChild?.let {
    insertBefore(node, it)
} ?: appendChild(node)